import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ExcelReader from 'components/common/FileController/ExcelReader';
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { Table, Pagination, Button, Input, Select, Spin } from 'antd';

@inject('userInfoStore', 'centerInfoStore')
@observer
class UserList extends Component {
  state = {
    userId: '',
    userNm: '',
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.userInfoStore.disUserList(pageIdx);
  };

  onSearch = () => {
    this.props.userInfoStore.onChangValue('userId', this.state.userId);
    this.props.userInfoStore.onChangValue('userNm', this.state.userNm);
    this.props.userInfoStore.disUserList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      userList,
      pageInfo,

      jobList,
      onChangValue,
      onViewMode, 
      onDetailData,
      disUserList,
      useUserYn,

      merUserList,
      excelUploadIng,
      onExcelUploadIng
    } = this.props.userInfoStore;
    const { sessionLoginInfo } = this.props;
    const { userId, userNm } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '7%', align: 'center' },
      { title: '사번', dataIndex: 'userId', width: '13%', align: 'center' },
      { title: '사원명', dataIndex: 'userNm', width: '10%', align: 'center' },
      { title: '직무', dataIndex: 'userJobNm', width: '15%', align: 'center' },
      { title: '성별', dataIndex: 'userSex', width: '8%', align: 'center',
        render: (item, record) => { return(
          item === 'M' ? <Fragment>남</Fragment> : <Fragment>여</Fragment>
        )}
      },
      { title: '지사', dataIndex: 'ceBranchNm', width: '10%', align: 'center' },
      { title: '지사코드', dataIndex: 'ceBranchCd', width: '10%', align: 'center' },
      { title: '센터', dataIndex: 'userCeNm', width: '10%', align: 'center' },
      { title: '센터코드', dataIndex: 'userCeCd', width: '10%', align: 'center' },
      { title: '사용유무', dataIndex: 'userUseYn', width: '7%', key: '', align: 'center',
        render: (item, record) => { return(
          <Button
            onClick={(e)=>{
              e.stopPropagation();
              useUserYn(record.userId, item);
            }}
          >{item === "Y" ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>}
          </Button>
        )}
      },
    ];
    return (
      <Spin
        tip="엑셀 업로드 중..." 
        spinning={excelUploadIng}
        size="large"
      >
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <CenterOptionList
              ceBranchCdValue={valCondition.ceBranchCd}
              ceCdValue={valCondition.ceCd}
              eBranchCdChange={(value)=>{
                onChangValue('ceBranchCd', value);
                onChangValue('ceCd', '');
                this.onSearch();
              }}
              ceCdfuncChange={(value)=>{
                onChangValue('ceCd', value);
                this.onSearch();
              }}
            />
          </div>
          <br />
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">직무</span>
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.userJobCd}
                onChange={(value)=>{
                  onChangValue('userJobCd', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                {jobList.length > 0 && jobList.map(item=>{
                  return(
                    (item.jobCd !== '개별사업자') &&
                    <Select.Option key={item.jobCd}>{item.jobNm}</Select.Option>
                  )
                })}
              </Select>
            </span>
            <span className="mo_srch">
              <span className="labal2">사번</span>
              <Input 
                placeholder="사번을 입력하세요"
                value={userId}
                onChange={(e)=>this.setState({userId: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">사원명</span>
              <Input 
                placeholder="사원명을 입력하세요"
                value={userNm}
                onChange={(e)=>this.setState({userNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">사용여부</span> 
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.userUseYn}
                onChange={(value)=>{
                  onChangValue('userUseYn', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                <Select.Option key={'Y'}>사용</Select.Option>
                <Select.Option key={'N'}>미사용</Select.Option>
              </Select>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>

        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disUserList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          <div className="button-right">
            <ul>
              <li>
                <Button 
                  type="primary"
                  onClick={()=>onViewMode('add')}
                >추가</Button>
              </li>
              <li>
                {/* 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-USER-LIST'}
                  schInfo={valCondition}
                />
              </li>
              {(sessionLoginInfo !== null 
              && sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
              && (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER))
              &&
              <Fragment>
                <li>
                  {/* 엑셀업로드 */}
                  <ExcelReader
                    actionType={'upload'}
                    excelUpload={(data)=>merUserList(data.slice(1, data.length))}
                    onExcelUploadIng={(boolen)=>onExcelUploadIng(boolen)}
                  />
                </li>
                <li>
                  {/* 탬플릿다운로드 */}
                  <ExcelReader
                    actionType={'templet'}
                    pageUrl={'DOWN-USER-LIST'}
                    schInfo={valCondition}
                  />
                </li>
              </Fragment>
              }
            </ul>
          </div>
        </div>
        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={userList}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                onDetailData(record);
              },
            };
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Spin>
    );
  }

}

export default withRouter(UserList);
